import { ReactNode } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

// The header of a detail page: what the record is, its headline (an amount) with its
// status, then the facts that identify it (reference, date, project...).
const DetailHeader = ({ kind, title, status, facts }: { kind: string; title: ReactNode; status?: ReactNode; facts: ReactNode[] }) => {
  const { t }: { t: any } = useTranslation();
  const shown = facts.filter((fact) => fact !== null && fact !== undefined && fact !== false && fact !== "");
  return (
    <Box>
      <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1, lineHeight: 1.5 }}>
        {t(kind)}
      </Typography>
      <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" useFlexGap sx={{ mt: 0.25 }}>
        <Typography variant="h3" component="h1" sx={{ fontVariantNumeric: "tabular-nums" }}>
          {title}
        </Typography>
        {status}
      </Stack>
      {shown.length > 0 && (
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap sx={{ mt: 1, color: "text.secondary" }}>
          {shown.map((fact, index) => (
            <Box key={index} component="span" display="inline-flex" alignItems="center" gap={1}>
              {index > 0 && <Box component="span" sx={{ opacity: 0.5 }}>·</Box>}
              <Typography component="span" variant="body2">
                {fact}
              </Typography>
            </Box>
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default DetailHeader;
